import { Flex, Heading, Spinner } from "@/ui";
import { useDisableNavigationEvents } from "@/hooks";
import { t } from "@/utils";
import AppImage from "@/components/AppImage";

export default function Waiting() {
  useDisableNavigationEvents();

  return (
    <Flex w="100%" direction="column" justify="center" align="center" grow={1}>
      <AppImage
        name="confirm_pair.svg"
        options={{
          imgProps: {
            w: "264",
            h: "192",
            mb: "2rem"
          }
        }}
      />
      <Heading as="h4" maxW="296" textAlign="center" mb="1.5rem">
        {t("pairing.confirm.heading")}
      </Heading>
      <Spinner color="primary" />
    </Flex>
  );
}
